(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , ], factory);
	else if(typeof exports === 'object')
		exports["circle"] = factory(require("@splat/constant"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else
		root["circle"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/colors.ts":
/*!***********************!*\
  !*** ./src/colors.ts ***!
  \***********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "background": function() { return /* binding */ background; },
/* harmony export */   "font": function() { return /* binding */ font; },
/* harmony export */   "border": function() { return /* binding */ border; },
/* harmony export */   "highlightBackground": function() { return /* binding */ highlightBackground; },
/* harmony export */   "highlightFont": function() { return /* binding */ highlightFont; },
/* harmony export */   "highlightBorder": function() { return /* binding */ highlightBorder; },
/* harmony export */   "smallBackground": function() { return /* binding */ smallBackground; },
/* harmony export */   "smallFont": function() { return /* binding */ smallFont; },
/* harmony export */   "smallHighlight": function() { return /* binding */ smallHighlight; },
/* harmony export */   "smallInvBackground": function() { return /* binding */ smallInvBackground; },
/* harmony export */   "smallInvFont": function() { return /* binding */ smallInvFont; },
/* harmony export */   "smallInvHighlightFont": function() { return /* binding */ smallInvHighlightFont; },
/* harmony export */   "smallInvHighlightBackground": function() { return /* binding */ smallInvHighlightBackground; }
/* harmony export */ });
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_0__);

var background = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.background;
var font = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.regularText;
var border = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.white;
var highlightBackground = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.primaryText;
var highlightFont = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.white;
var highlightBorder = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.backgroundHighlight;
var smallBackground = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.regularText;
var smallFont = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.white;
var smallHighlight = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.normalText;
var smallInvBackground = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.background;
var smallInvFont = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.regularText;
var smallInvHighlightFont = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.primaryText;
var smallInvHighlightBackground = _splat_constant__WEBPACK_IMPORTED_MODULE_0__.CommonColors.white;

/***/ }),

/***/ "./src/sizes.ts":
/*!**********************!*\
  !*** ./src/sizes.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "size": function() { return /* binding */ size; },
/* harmony export */   "smallSize": function() { return /* binding */ smallSize; },
/* harmony export */   "highlightSize": function() { return /* binding */ highlightSize; },
/* harmony export */   "smallHighlightSize": function() { return /* binding */ smallHighlightSize; },
/* harmony export */   "smallLineHeight": function() { return /* binding */ smallLineHeight; }
/* harmony export */ });
var size = 24;
var smallSize = 12;
var highlightSize = 4;
var smallHighlightSize = 2;
var smallLineHeight = 12;

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "circleContainerClassName": function() { return /* binding */ circleContainerClassName; },
/* harmony export */   "normalDisabledCircleContainerClassName": function() { return /* binding */ normalDisabledCircleContainerClassName; },
/* harmony export */   "smallCircleContainerClassName": function() { return /* binding */ smallCircleContainerClassName; },
/* harmony export */   "smallDisabledCircleContainerClassName": function() { return /* binding */ smallDisabledCircleContainerClassName; },
/* harmony export */   "smallInvCircleContainerClassName": function() { return /* binding */ smallInvCircleContainerClassName; },
/* harmony export */   "smallInvDisabledCircleContainerClassName": function() { return /* binding */ smallInvDisabledCircleContainerClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./colors */ "./src/colors.ts");
/* harmony import */ var _sizes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sizes */ "./src/sizes.ts");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_5__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var circleContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.width)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.size)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.height)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.size)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(_sizes__WEBPACK_IMPORTED_MODULE_2__.highlightSize), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.margin)(0), {
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(50),
  background: _colors__WEBPACK_IMPORTED_MODULE_1__.background.toString(),
  backgroundClip: 'content-box',
  color: _colors__WEBPACK_IMPORTED_MODULE_1__.font.toString(),
  cursor: 'pointer',
  boxSizing: 'content-box',
  outline: 'none',
  border: 'none',
  $nest: {
    '&:hover': _objectSpread(_objectSpread({}, (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(0)), {}, {
      background: _colors__WEBPACK_IMPORTED_MODULE_1__.highlightBackground.toString(),
      color: _colors__WEBPACK_IMPORTED_MODULE_1__.highlightFont.toString(),
      border: (0,csx__WEBPACK_IMPORTED_MODULE_4__.border)({
        color: _colors__WEBPACK_IMPORTED_MODULE_1__.highlightBorder.toString(),
        style: 'solid',
        width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.highlightSize)
      })
    })
  }
});
var disabledCircleContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  border: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)('none'),
  opacity: 0.5,
  cursor: 'not-allowed'
});
var normalDisabledCircleContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.classes)(disabledCircleContainerClassName, (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  color: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)(_colors__WEBPACK_IMPORTED_MODULE_1__.font.toString()),
  paddingTop: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.highlightSize)),
  paddingBottom: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.highlightSize)),
  paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.highlightSize)),
  paddingRight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.highlightSize)),
  $nest: {
    '&:hover': {
      background: _colors__WEBPACK_IMPORTED_MODULE_1__.background.toString(),
      backgroundClip: 'content-box',
      color: _colors__WEBPACK_IMPORTED_MODULE_1__.font.toString(),
      border: 'none'
    }
  }
}));
var smallCircleContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.width)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallSize)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.height)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallSize)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallHighlightSize), {
  background: _colors__WEBPACK_IMPORTED_MODULE_1__.smallBackground.toString(),
  color: _colors__WEBPACK_IMPORTED_MODULE_1__.smallFont.toString(),
  backgroundClip: 'content-box',
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallLineHeight),
  $nest: {
    '&:hover': {
      background: _colors__WEBPACK_IMPORTED_MODULE_1__.smallHighlight.toString(),
      borderWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallHighlightSize),
      borderColor: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)('transparent'),
      backgroundClip: 'content-box'
    }
  }
});
var smallDisabledCircleContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.classes)(disabledCircleContainerClassName, (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  color: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)(_colors__WEBPACK_IMPORTED_MODULE_1__.smallFont.toString()),
  $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "&.".concat(smallCircleContainerClassName, ":hover"), _objectSpread(_objectSpread({}, (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallHighlightSize)), {}, {
    background: _colors__WEBPACK_IMPORTED_MODULE_1__.smallBackground.toString(),
    backgroundClip: 'content-box',
    color: _colors__WEBPACK_IMPORTED_MODULE_1__.smallFont.toString(),
    border: 'none'
  }))
}));
var smallInvCircleContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.width)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallSize)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.height)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallSize)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallHighlightSize), {
  background: _colors__WEBPACK_IMPORTED_MODULE_1__.smallInvBackground.toString(),
  color: _colors__WEBPACK_IMPORTED_MODULE_1__.smallInvFont.toString(),
  backgroundClip: 'content-box',
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallLineHeight),
  $nest: {
    '&:hover': {
      background: _colors__WEBPACK_IMPORTED_MODULE_1__.smallInvHighlightBackground.toString(),
      color: _colors__WEBPACK_IMPORTED_MODULE_1__.smallInvHighlightFont.toString(),
      borderWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallHighlightSize),
      borderColor: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)('transparent'),
      backgroundClip: 'content-box'
    }
  }
});
var smallInvDisabledCircleContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.classes)(disabledCircleContainerClassName, (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  color: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)(_colors__WEBPACK_IMPORTED_MODULE_1__.smallInvFont.toString()),
  $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "&.".concat(smallInvCircleContainerClassName, ":hover"), _objectSpread(_objectSpread({}, (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(_sizes__WEBPACK_IMPORTED_MODULE_2__.smallHighlightSize)), {}, {
    background: _colors__WEBPACK_IMPORTED_MODULE_1__.background.toString(),
    backgroundClip: 'content-box',
    color: _colors__WEBPACK_IMPORTED_MODULE_1__.font.toString(),
    border: 'none'
  }))
}));

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CircleColors": function() { return /* reexport module object */ _colors__WEBPACK_IMPORTED_MODULE_9__; },
/* harmony export */   "CircleSizes": function() { return /* reexport module object */ _sizes__WEBPACK_IMPORTED_MODULE_10__; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./colors */ "./src/colors.ts");
/* harmony import */ var _sizes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./sizes */ "./src/sizes.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var CircleButton = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(CircleButton, _tsx$Component);

  var _super = _createSuper(CircleButton);

  function CircleButton() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, CircleButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "icon", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "small", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "inverted", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(CircleButton, [{
    key: "onClick",
    value: function onClick() {}
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var icon = this.icon,
          small = this.small,
          disabled = this.disabled,
          onClick = this.onClick,
          inverted = this.inverted;
      return h("button", {
        "attrs": {
          "type": 'button',
          "disabled": disabled
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_8__.circleContainerClassName, small && !inverted && _style__WEBPACK_IMPORTED_MODULE_8__.smallCircleContainerClassName, small && inverted && _style__WEBPACK_IMPORTED_MODULE_8__.smallInvCircleContainerClassName, disabled && (small ? inverted ? _style__WEBPACK_IMPORTED_MODULE_8__.smallInvDisabledCircleContainerClassName : _style__WEBPACK_IMPORTED_MODULE_8__.smallDisabledCircleContainerClassName : _style__WEBPACK_IMPORTED_MODULE_8__.normalDisabledCircleContainerClassName)),
        "on": {
          "click": onClick
        }
      }, [h("i", {
        "class": icon
      })]);
    }
  }]);

  return CircleButton;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], CircleButton.prototype, "icon", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], CircleButton.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], CircleButton.prototype, "small", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], CircleButton.prototype, "inverted", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Emit)('click')], CircleButton.prototype, "onClick", null);

CircleButton = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Component], CircleButton);
/* harmony default export */ __webpack_exports__["default"] = (CircleButton);

}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map